import * as classNames from "classnames";
import * as React from "react";
import { alertsClasses as myClasses } from "../../";

import "./styles.css";

import { HTMLDivProps } from "@blueprintjs/core";

interface IEmptyProps extends HTMLDivProps {
  title: string;
  onUpdateToolBar(topBarProps: any): void;
}

class Empty extends React.PureComponent<IEmptyProps> {
  public constructor(props: IEmptyProps) {
    super(props);
    this.props.onUpdateToolBar(null);
  }

  public render() {
    const { title, className } = this.props;
    return (
      <div className={classNames(myClasses.ALERTS_CONTENT_EMPTY, className)}>
        {title}
      </div>
    );
  }
}

export default Empty;



// WEBPACK FOOTER //
// ./src/controllers/alerts/empty/empty.tsx